import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { HomeAction } from '../../store/home/home.actions';

@Component({
  selector: 'pa-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private route: ActivatedRoute, private store: Store) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      let id: string = params['id'];
      this.checkTrackingId(id);
    });
  }

  checkTrackingId(id: string) {
    this.store.dispatch(new HomeAction(id));
  }

}
